<!-- hw-h5-2 -->

<template>
  <div>
    <!-- hw-h5-2 -->
  </div>
</template>

<script>
import request from "@/util/axios";
import { Toast } from "vant";

export default {
  created() {
    document.cookie = "hw_h5_from_origin=" + this.$route.query.hw_h5_from_origin + "; path=/; max-age=" + 60 * 60;

    this.$store.commit("SET_ACCESS_TOKEN", this.$route.query.token);

    this.go_supplier({
      supplier: this.$route.query.supplier,
    });
  },

  methods: {
    go_supplier(e) {
      Toast("正在跳转 ..");

      request.post("/mall/hw-h5-" + e.supplier + "-index").then((res) => {
        location.href = res.data;
      });
    },
  },
};
</script>
